type AppRuntimeConfig = {
    BASE_URL?: string;
    FILES_BASE_URL?: string;
    APP_ENV?: string;
};

const defaultApiUrl = 'https://gestore-1001936526e8.herokuapp.com';

const runtimeConfig: AppRuntimeConfig =
    typeof window !== 'undefined'
        ? ((window as any).APP_CONFIG || {})
        : {};

export const APP_ENV =
    runtimeConfig.APP_ENV ||
    process.env.REACT_APP_APP_ENV ||
    'production';

export const BASE_URL =
    runtimeConfig.BASE_URL ||
    process.env.REACT_APP_BASE_URL ||
    defaultApiUrl;

export const FILES_BASE_URL =
    runtimeConfig.FILES_BASE_URL ||
    process.env.REACT_APP_FILES_BASE_URL ||
    BASE_URL;
